import * as $ from "jquery";
import { ConsentHubClient } from "../../common/ConsentHubV2";
import Environment from "../../common/environment";

const LOCALE_CACHE_KEY = "bxp.currentLocale";

export default class CountrySpecificBlock {
  componentRoot: JQuery<HTMLElement>;
  params: any;
  consentHub: ConsentHubClient;
  blockDisplayedEvent: Event;
  
  constructor(componentRoot: HTMLElement, params: any) {
    this.componentRoot = $(componentRoot);
    this.params = { ...params };

    this.consentHub = new ConsentHubClient();
    this.blockDisplayedEvent = new Event(
      "country-specific-block-display-rendered"
    );

    this.init();
  }

  async init() {
    try {
      if (this.params.useGeoIpService) {
        const data = await this.getLocaleFromGeoIpService();

        if (this.params.countries.includes(data)) {
          this.displayCountrySpecificBlock();
          return;
        }
      } else {
        const data = await this.consentHub.requestConfig();
        let locale = data.locale || null;
        if (this.params.countries.includes(locale)) {
          this.displayCountrySpecificBlock();
          return;
        }
      }
    } catch (e) {
      //
    }

    this.displayDefaultBlock();
  }

  displayCountrySpecificBlock() {
    $(`#${this.params.countrySpecificId}`).removeClass("hide-all");
    document.dispatchEvent(this.blockDisplayedEvent);
    $(`#${this.params.defaultId}`).addClass("hide-all");
  }

  displayDefaultBlock() {
    document.dispatchEvent(this.blockDisplayedEvent);
  }

  async getLocaleFromGeoIpService() {
    let currentLocale = sessionStorage.getItem(LOCALE_CACHE_KEY);
    if (currentLocale) {
      return currentLocale;
    }

    try {
      const response = await fetch(
        `${Environment.getWacIntegrationUrl()}/endpoint/location`
      );
      const json = await response.json();
      // eslint-disable-next-line no-undef
      const locale = json.countryIsoCode || DEFAULT_LOCALE;
      sessionStorage.setItem(LOCALE_CACHE_KEY, locale);
      return locale;
    } catch (e) {
      // eslint-disable-next-line no-undef
      return DEFAULT_LOCALE;
    }
  }
}
